import React from 'react';
import { FormattedMessage } from 'react-intl';
import Empty from "./Empty";
import TableRow from "./TableRow";
import classes from './styles.module.css';

function PayoutsTable({ payouts, loading }) {

    const list = Array.isArray(payouts) ? payouts : [];

    return (
        <div className={classes.Card}>
            <div className={classes.Table}>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <FormattedMessage id="PayoutsTable.table.status" defaultMessage="Статус" />
                            </th>
                            <th>
                                <FormattedMessage id="PayoutsTable.table.recipient" defaultMessage="Получатель" />
                            </th>
                            <th>
                                <FormattedMessage id="PayoutsTable.table.phone" defaultMessage="Телефон" />
                            </th>
                            <th>
                                <FormattedMessage id="PayoutsTable.table.amount" defaultMessage="Сумма" />
                            </th>
                            <th>
                                <FormattedMessage id="PayoutsTable.table.pan" defaultMessage="PAN" />
                            </th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {loading && list.length > 0 ? (
                            list.map((el, idx) => (
                                <TableRow
                                    key={
                                        el.id != null
                                            ? `tx-${el.id}`
                                            : `nci-${idx}-${el.firstPart || ''}-${el.lastPart || ''}-${el.amount || ''}`
                                    }
                                    data={el}
                                />
                            ))
                        ) : (
                            <Empty />
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default PayoutsTable;



// WEBPACK FOOTER //
// ./src/Components/PayoutsTable/index.js